<template>
  <div class="container" style="width: 1900px; page-break-after:always;">
    <!-- 打印按钮 -->
    <div class="print">
      <el-button v-loading="loading" type="primary" @click="downloadPDF">下载</el-button>
    </div>
    <div>
      <iframe id="iframe"
              refs="iframe"
              :src="iframeSrc"
              :style="{width: '1900px', height: autoHeight}"
              allowfullscreen="true" scrolling="no" frameborder="0" />
    </div>
  </div>
</template>

<script>
import {createPdf, getFileOssUrl, getPdfFileName} from '../../../api/util'
import {getCountPdf, getOssToken} from "../../../api/order"
import OSS from "ali-oss";

export default {
  name: 'WorkerPdfPreview',
  data() {
    return {
      loading: false,
      iframeSrc: '',
      timer: null,
      autoHeight: '1200px'
    }
  },
  mounted() {
  },
  created() {
    const appo_task_id = this.$route.query.appo_task_id
    const contact_person_type ='same'
    const company_id = this.$route.query.company_id
    this.iframeSrc = 'https://erp-pre.zhian-design.com/pdf/worker?appo_task_id=' + appo_task_id + '&contact_person_type=' + contact_person_type + '&company_id=' + company_id
    //this.iframeSrc = 'http://erp-api.huyudev.com/pdf/worker?appo_task_id=' + appo_task_id + '&contact_person_type=' + contact_person_type + '&company_id=1'
    getCountPdf({ appo_task_id: this.$route.query.appo_task_id, contact_person_type: 'same', company_id: 1, get_page: 1 }).then((res) => {
      if (res.data.data) {
        this.autoHeight = 1170 * res.data.data + 'px'
      }
    })
  },
  methods: {
    downloadPDF() {
      if (this.loading) {
        this.$message.error('正在下载中，请耐心等待')
        return false
      }
      this.$message.success('提交下载成功，请耐心等待')
      this.loading = true
      localStorage.removeItem('download_pdf')
      createPdf({ 'pdf_type': 'worker_construction_report', pdf_info: { appo_task_id: this.$route.query.appo_task_id, contact_person_type: this.$route.query.contact_person_type, company_id: this.$route.query.company_id }}).then((res) => {
        this.timer = setInterval(async () => {
          await getFileOssUrl({download_token: res.data.data}).then((ossResult) => {
            if (ossResult.data.data) {
              const fileUrl = ossResult.data.data.replace('https://zhian-erp-files.oss-cn-shanghai.aliyuncs.com/', '')
              console.log('osssresult....', ossResult.data.data)
              getPdfFileName({ appo_task_id: this.$route.query.appo_task_id }).then((res) => {
                if (res.data.data) {
                  this.parsePdfPath(fileUrl, res.data.data)
                }
              })
              this.loading = false
              clearInterval(this.timer)
            }
          })
          if (!this.loading) {
            return false
          }
          const pdfContent = localStorage.getItem('download_pdf')
          console.log('download_pdf.........', pdfContent)
          if (pdfContent) {
            const content = JSON.parse(pdfContent)
            console.log('content......', content)
            if (content && content.oss_pdf_url && content.info && content.info.pdf_type === 'worker_construction_report') {
              console.log('jflkdsfjldsalfdsjfdslfjdsfdsfdsaf')
              localStorage.removeItem('download_pdf')
              const link = document.createElement('a')
              // 设置a标签的href（点击地址）
              link.href = content.oss_pdf_url
              // 设置a标签属性
              link.setAttribute('download', '施工人员信息.pdf')
              // 点击a标签

              document.body.appendChild(link)
              link.click()
              // 移除a标签
              document.body.removeChild(link)
              //window.open(content.oss_pdf_url, '_blank')
              this.loading = false
              clearInterval(this.timer)
            }
          }
        }, 1000)
      })
    },
    parsePdfPath(contentUrl, title) {
      getOssToken({ file_suffix: 'pdf', only_download: 1 }).then((res) => {
        const ossData = res.data.data
        const client = new OSS({
          region: 'oss-' + ossData.region_id,
          accessKeySecret: ossData.access_secret,
          accessKeyId: ossData.access_id,
          stsToken: ossData.secret_token,
          bucket: ossData.bucket
        })
        const filename = title + '.pdf'
        const response = {
          'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
        }
        let fileUrl = contentUrl
        fileUrl = fileUrl.substr(0, fileUrl.indexOf('.')) + '.pdf'
        console.log('fileUrl........', fileUrl)
        const url = client.signatureUrl(fileUrl, { response })
        const iframe = document.createElement('iframe')
        iframe.style.display = 'none'
        iframe.src = url
        document.body.appendChild(iframe)
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 100)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  font-family: 'Calibri';
  margin: 0 auto;
  width: 1700px;
  .print{
    position: fixed;
    height: 56px;
    width: 100%;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    z-index: 100;
  }
}
.pdf-items {
  width: 1700px; overflow: hidden; margin-top: 2px; page-break-after:always;
}
</style>
<style>
.page{
  box-sizing: border-box;
  border: 1px solid #666;
  margin-bottom: 8px;
}
#total-page {
  width: 1700px;
  margin: 0 auto;
  overflow: hidden;
}
.hidePage .page{
  border: none !important;
  margin-bottom: 0 !important;
}
.hidePage .splice::after,.hidePage .splice::before{
  display: none !important;
}
@media print {
  @page{
    size:auto;
    margin: 0mm;
  }
  .splice::after,.splice::before{
    display: none !important;
  }
  .page{
    border: none !important;
    margin-bottom: 0 !important;
  }
  .container{
    -webkit-print-color-adjust:exact;
    border: none !important;
  }
  .print{
    display: none !important;
  }
  .page-print-hide{
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order/components/worker-pdf-preview.vue